import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';

export default {
  name: 'EsgOrderComplete',

  components: {
    SharedHeader,
    SharedFooter,
  },

  data: () => {
    return {
      salesQrCode: '',
    };
  },

  created() {
    this.salesQrCode = window.sessionStorage.getItem('salesQrCode');
  },
};
